<div #shell class="site-head absolute top-0 inset-x-0 z-50">
  <!-- Utility bar -->
  <div class="util-bar">
    <div class="util-inner max-w-7xl mx-auto px-4 sm:px-6">
      <div class="util-group">
        <a
          class="util-status"
          [routerLink]="['/', lang.currentLang(), 'status']"
          target="_blank"
          rel="noopener noreferrer"
          >{{ 'header.utility.status' | transloco }}</a
        >
        <span class="util-sep" aria-hidden="true"></span>
        <a class="util-link hidden sm:inline-flex" href="tel:+33184754308">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
            />
          </svg>
          01 84 75 43 08
        </a>
        <span class="util-sep hidden md:inline-block" aria-hidden="true"></span>
        <a class="util-link hidden md:inline-flex" href="mailto:contact@ancelade.com">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
            />
          </svg>
          contact&#64;ancelade.com
        </a>
      </div>
      <div class="util-group">
        <a class="util-link" routerLink="/contact" (click)="closeAll()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"
            />
          </svg>
          {{ 'header.utility.support' | transloco }}
        </a>
        <span class="util-sep" aria-hidden="true"></span>
        <div class="lang-select">
          <button
            type="button"
            class="util-lang"
            (click)="toggleLang()"
            [attr.aria-expanded]="langOpen()"
            [attr.aria-label]="'header.utility.language' | transloco"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 21a9 9 0 100-18 9 9 0 000 18zm0 0a8.949 8.949 0 004.951-1.488A3.987 3.987 0 0013 16h-2a3.987 3.987 0 00-3.951 3.512A8.949 8.949 0 0012 21zm3-11a3 3 0 11-6 0 3 3 0 016 0z"
              />
            </svg>
            <span>{{ currentLanguage().code | uppercase }}</span>
            <svg
              class="lang-caret"
              [class.open]="langOpen()"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              aria-hidden="true"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
            </svg>
          </button>
          @if (langOpen()) {
            <ul class="lang-menu" aria-label="Langue">
              @for (l of lang.languages; track l.code) {
                <li>
                  <button
                    type="button"
                    class="lang-option"
                    [class.active]="l.code === lang.currentLang()"
                    [attr.aria-pressed]="l.code === lang.currentLang()"
                    (click)="selectLang(l.code)"
                  >
                    <span class="lang-flag" aria-hidden="true">{{ l.flag }}</span>
                    <span class="lang-name">{{ l.label }}</span>
                    @if (l.code === lang.currentLang()) {
                      <svg
                        class="lang-check"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.5"
                        aria-hidden="true"
                      >
                        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                      </svg>
                    }
                  </button>
                </li>
              }
            </ul>
          }
        </div>
        <span class="util-sep" aria-hidden="true"></span>
        <app-theme-toggle />
      </div>
    </div>
  </div>
  <div class="nav-strip px-4" [class.is-floating]="floating()">
    <header class="header-bar max-w-7xl mx-auto">
      <nav class="px-3 sm:px-4" [attr.aria-label]="'header.mainNavLabel' | transloco">
        <div class="flex items-center justify-between h-16">
          <!-- Logo -->
          <a routerLink="/" class="flex items-center group" (click)="closeAll()">
            <img [src]="logoSrc()" alt="Ancelade" width="145" height="39" class="h-8 w-auto" />
          </a>

          <!-- Desktop Navigation with Mega Menu -->
          <div class="hidden xl:flex items-center space-x-1">
            <!-- Accueil (simple link) -->
            <a
              routerLink="/"
              routerLinkActive="active-link"
              [routerLinkActiveOptions]="{ exact: true }"
              class="nav-link"
            >
              {{ 'header.home' | transloco }}
            </a>

            <!-- Mega Menu Categories -->
            @for (category of megaMenuCategories; track category.id) {
              <div class="relative" (mouseenter)="openMegaMenu(category.id)" (mouseleave)="closeMegaMenu()">
                <button
                  type="button"
                  class="nav-link flex items-center gap-1"
                  [class.active-link]="activeMegaMenu() === category.id"
                  [attr.aria-expanded]="activeMegaMenu() === category.id"
                >
                  {{ category.labelKey | transloco }}
                  <svg
                    class="w-4 h-4 transition-transform duration-200"
                    [class.rotate-180]="activeMegaMenu() === category.id"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
              </div>
            }

            <!-- Simple Links -->
            <a routerLink="/about" routerLinkActive="active-link" class="nav-link">
              {{ 'header.about' | transloco }}
            </a>
            <a routerLink="/contact" routerLinkActive="active-link" class="nav-link">
              {{ 'header.contact' | transloco }}
            </a>
          </div>

          <!-- Right side: Espace client + Inscription + Theme toggle + Mobile menu -->
          <div class="flex items-center space-x-2">
            <a
              [href]="panelUrl"
              appConversion="header-login"
              target="_blank"
              rel="noopener noreferrer"
              class="cta-ghost hidden xl:inline-flex items-center justify-center gap-2 px-[14px] py-[11px] rounded-full text-sm font-semibold leading-none transition-colors"
            >
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.75">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
                />
              </svg>
              {{ 'header.clientArea' | transloco }}
            </a>
            <a
              [href]="registerUrl"
              appConversion="header-register"
              target="_blank"
              rel="noopener noreferrer"
              class="hidden xl:inline-flex items-center justify-center gap-2 px-[18px] py-[11px] rounded-full bg-[var(--accent)] text-[var(--on-accent)] text-sm font-semibold leading-none hover:bg-[var(--accent-hover)] transition-colors shadow-[0_4px_14px_rgba(0,174,255,0.3)]"
            >
              {{ 'header.signUp' | transloco }}
              <svg class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75" />
              </svg>
            </a>

            <!-- Mobile menu button -->
            <button
              type="button"
              class="mobile-menu-toggle xl:hidden"
              (click)="toggleMobile()"
              [attr.aria-expanded]="mobileOpen()"
              aria-controls="mobile-menu"
              [attr.aria-label]="'header.mobileMenuLabel' | transloco"
            >
              <svg
                class="mobile-burger-icon w-6 h-6 text-[var(--text-primary)]"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Mobile Navigation with Accordion -->
        @if (mobileOpen()) {
          <button
            type="button"
            class="mobile-menu-backdrop xl:hidden"
            (click)="closeMobile()"
            tabindex="-1"
            aria-label="Fermer le menu"
          ></button>
          <div id="mobile-menu" class="mobile-menu-panel xl:hidden">
            <div class="mobile-menu-content">
              <div class="mobile-account-actions mobile-account-actions--top">
                <a
                  [href]="panelUrl"
                  appConversion="mobile-login"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="mobile-account-link secondary"
                >
                  {{ 'header.clientArea' | transloco }}
                </a>
                <a
                  [href]="registerUrl"
                  appConversion="mobile-register"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="mobile-account-link primary"
                >
                  {{ 'header.signUp' | transloco }}
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12h15m0 0l-6-6m6 6l-6 6" />
                  </svg>
                </a>
              </div>
              <div class="mobile-quick-nav" aria-label="Navigation rapide">
                <a
                  routerLink="/"
                  routerLinkActive="active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  (click)="closeMobile()"
                  class="mobile-quick-link"
                >
                  {{ 'header.home' | transloco }}
                </a>
                <a routerLink="/about" routerLinkActive="active" (click)="closeMobile()" class="mobile-quick-link">
                  {{ 'header.about' | transloco }}
                </a>
                <a routerLink="/contact" routerLinkActive="active" (click)="closeMobile()" class="mobile-quick-link">
                  {{ 'header.contact' | transloco }}
                </a>
              </div>

              <div class="mobile-universes">
                @for (category of megaMenuCategories; track category.id) {
                  <div class="mobile-category" [attr.data-universe]="category.id">
                    <button
                      type="button"
                      class="mobile-category-trigger"
                      [class.active]="mobileAccordion() === category.id"
                      (click)="toggleMobileAccordion(category.id)"
                      [attr.aria-expanded]="mobileAccordion() === category.id"
                      [attr.aria-controls]="'mobile-universe-' + category.id"
                    >
                      <span class="mobile-category-copy">
                        <span class="mobile-category-kicker">{{
                          'header.' + category.id + '.universeLabel' | transloco
                        }}</span>
                        <strong>{{ 'header.' + category.id + '.universeBrand' | transloco }}</strong>
                      </span>
                      <span class="mobile-category-toggle" aria-hidden="true">
                        <svg
                          [class.rotate-180]="mobileAccordion() === category.id"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                      </span>
                    </button>

                    @if (mobileAccordion() === category.id) {
                      <div class="mobile-universe-panel" [id]="'mobile-universe-' + category.id">
                        <div class="mobile-universe-intro">
                          <p class="mobile-universe-tagline">{{ 'header.' + category.id + '.tagline' | transloco }}</p>
                          <p class="mobile-universe-description">
                            {{ 'header.' + category.id + '.description' | transloco }}
                          </p>
                        </div>

                        @for (subcat of category.subcategories; track subcat.id) {
                          <section class="mobile-product-section">
                            <div class="mobile-product-section-title">
                              <span class="mobile-section-icon" aria-hidden="true">
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">
                                  <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="subcat.icon" />
                                </svg>
                              </span>
                              <span>{{ subcat.label | transloco }}</span>
                            </div>

                            <div class="mobile-product-grid">
                              @for (item of subcat.items; track item.label) {
                                <a
                                  [routerLink]="item.path"
                                  [queryParams]="item.queryParams"
                                  (click)="closeMobile()"
                                  class="mobile-product-card"
                                  [style.--item-color]="item.color"
                                >
                                  <span class="mobile-product-icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7">
                                      <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="item.icon" />
                                    </svg>
                                  </span>
                                  <span class="mobile-product-copy">
                                    <strong>{{ item.label | transloco }}</strong>
                                    <span>{{ item.description | transloco }}</span>
                                    @if (item.highlight) {
                                      <small>{{ item.highlight | transloco }}</small>
                                    }
                                  </span>
                                  <svg
                                    class="mobile-product-arrow"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    aria-hidden="true"
                                  >
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7" />
                                  </svg>
                                </a>
                              }
                            </div>
                          </section>
                        }

                        <div class="mobile-universe-footer">
                          <span>{{ category.labelKey | transloco }}</span>
                          <span aria-hidden="true">Ancelade Cloud</span>
                        </div>
                      </div>
                    }
                  </div>
                }
              </div>

              <div class="mobile-utility-card">
                <div class="mobile-status-row">
                  <a
                    class="util-status"
                    [routerLink]="['/', lang.currentLang(), 'status']"
                    target="_blank"
                    rel="noopener noreferrer"
                    >{{ 'header.utility.status' | transloco }}</a
                  >
                  <app-theme-toggle />
                </div>

                <fieldset class="mobile-lang" [attr.aria-label]="'header.utility.language' | transloco">
                  @for (l of lang.languages; track l.code) {
                    <button
                      type="button"
                      class="mobile-lang-chip"
                      [class.active]="l.code === lang.currentLang()"
                      (click)="selectLang(l.code)"
                    >
                      <span aria-hidden="true">{{ l.flag }}</span>
                      {{ l.code | uppercase }}
                    </button>
                  }
                </fieldset>

                <div class="mobile-contact-grid">
                  <a class="mobile-contact-link" href="tel:+33184754308">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
                      />
                    </svg>
                    <span>01 84 75 43 08</span>
                  </a>
                  <a class="mobile-contact-link" href="mailto:contact@ancelade.com">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                      />
                    </svg>
                    <span>contact&#64;ancelade.com</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        }
      </nav>
    </header>

    <!-- Mega Menu Dropdown -->
    @if (activeMegaMenu()) {
      <div
        class="mega-menu-dropdown mt-2 max-w-7xl mx-auto"
        (mouseenter)="keepMegaMenuOpen()"
        (mouseleave)="closeMegaMenu()"
      >
        @for (category of megaMenuCategories; track category.id) {
          @if (activeMegaMenu() === category.id) {
            <!-- Cloud: Custom Layout -->
            @if (category.id === 'cloud') {
              <div class="cloud-layout">
                <!-- Left: Intro -->
                <div class="cloud-intro">
                  <span class="cloud-brand"
                    >{{ 'header.cloud.universeLabel' | transloco }}<br /><strong>{{
                      'header.cloud.universeBrand' | transloco
                    }}</strong></span
                  >
                  <p class="cloud-tagline">{{ 'header.cloud.tagline' | transloco }}</p>
                  <p class="cloud-desc">{{ 'header.cloud.description' | transloco }}</p>
                </div>

                <!-- Center: 3 curated products -->
                <div class="cloud-products">
                  <a
                    routerLink="/vps-standard"
                    [queryParams]="{ type: 'kvm' }"
                    (click)="closeAll()"
                    class="cloud-product"
                  >
                    <img
                      src="menu/intel.png"
                      alt="Intel"
                      width="500"
                      height="500"
                      loading="lazy"
                      decoding="async"
                      class="cloud-logo-img"
                    />
                    <div class="cloud-product-info">
                      <span class="cloud-product-name">{{ 'header.cloud.vpsStandard' | transloco }}</span>
                      <span class="cloud-product-desc">{{ 'header.cloud.vpsStandardDesc' | transloco }}</span>
                    </div>
                  </a>
                  <a
                    routerLink="/vps-performance"
                    [queryParams]="{ type: 'kvm' }"
                    (click)="closeAll()"
                    class="cloud-product"
                  >
                    <img
                      src="menu/amd.png"
                      alt="AMD Ryzen"
                      width="500"
                      height="500"
                      loading="lazy"
                      decoding="async"
                      class="cloud-logo-img"
                    />
                    <div class="cloud-product-info">
                      <span class="cloud-product-name">{{ 'header.cloud.vpsPerformance' | transloco }}</span>
                      <span class="cloud-product-desc">{{ 'header.cloud.vpsPerformanceDesc' | transloco }}</span>
                    </div>
                  </a>
                  <a routerLink="/plesk-dedicated" (click)="closeAll()" class="cloud-product">
                    <img
                      src="logos/plesk.png"
                      alt="Plesk"
                      width="1254"
                      height="1254"
                      loading="lazy"
                      decoding="async"
                      class="cloud-logo-img"
                    />
                    <div class="cloud-product-info">
                      <span class="cloud-product-name">{{ 'header.cloud.pleskDedicated' | transloco }}</span>
                      <span class="cloud-product-desc">{{ 'header.cloud.pleskDedicatedDesc' | transloco }}</span>
                    </div>
                  </a>
                </div>

                <!-- Right: Promo cards -->
                <div class="cloud-promos">
                  <a routerLink="/antiddos" (click)="closeAll()" class="cloud-promo accent">
                    <div class="cloud-promo-top">
                      <div class="cloud-promo-text">
                        <span class="cloud-promo-label">{{ 'header.cloud.antiDdos' | transloco }}</span>
                        <span class="cloud-promo-price">{{ 'header.cloud.antiDdosPromo' | transloco }}</span>
                      </div>
                      <svg
                        class="w-6 h-6 text-white/60"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.5"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z"
                        />
                      </svg>
                    </div>
                  </a>
                  <div class="cloud-promo subtle">
                    <span class="cloud-promo-sub">{{ 'header.cloud.antiDdosPromoSub' | transloco }}</span>
                    <span class="cloud-promo-hint">{{ 'header.cloud.antiDdosPromoHint' | transloco }}</span>
                  </div>
                </div>

                <!-- Bottom: Banner -->
                <a routerLink="/dedicated" (click)="closeAll()" class="cloud-banner">
                  <div class="cloud-banner-illus">
                    <svg viewBox="0 0 80 50" fill="none">
                      <rect
                        x="5"
                        y="6"
                        width="28"
                        height="38"
                        rx="2"
                        stroke="rgba(42,127,255,0.5)"
                        stroke-width="1.2"
                      />
                      <rect x="9" y="12" width="20" height="2" rx="1" fill="rgba(42,127,255,0.35)" />
                      <rect x="9" y="17" width="20" height="2" rx="1" fill="rgba(42,127,255,0.3)" />
                      <rect x="9" y="22" width="20" height="2" rx="1" fill="rgba(42,127,255,0.25)" />
                      <rect x="9" y="27" width="20" height="2" rx="1" fill="rgba(42,127,255,0.2)" />
                      <circle cx="11" cy="36" r="1.5" fill="#22c55e" opacity="0.8" />
                      <circle cx="16" cy="36" r="1.5" fill="#3b82f6" opacity="0.5" />
                      <rect
                        x="42"
                        y="3"
                        width="32"
                        height="44"
                        rx="2"
                        stroke="rgba(42,127,255,0.6)"
                        stroke-width="1.2"
                      />
                      <rect x="46" y="9" width="24" height="2" rx="1" fill="rgba(42,127,255,0.35)" />
                      <rect x="46" y="14" width="24" height="2" rx="1" fill="rgba(42,127,255,0.3)" />
                      <rect x="46" y="19" width="24" height="2" rx="1" fill="rgba(42,127,255,0.25)" />
                      <rect x="46" y="24" width="24" height="2" rx="1" fill="rgba(42,127,255,0.2)" />
                      <rect x="46" y="29" width="24" height="2" rx="1" fill="rgba(42,127,255,0.15)" />
                      <circle cx="48" cy="40" r="1.5" fill="#22c55e" opacity="0.8" />
                      <circle cx="53" cy="40" r="1.5" fill="#22c55e" opacity="0.5" />
                    </svg>
                  </div>
                  <div class="cloud-banner-center">
                    <span class="cloud-banner-title" [innerHTML]="'header.cloud.dedicatedBanner' | transloco"></span>
                    <span class="cloud-banner-sub">{{ 'header.cloud.dedicatedBannerSub' | transloco }}</span>
                  </div>
                  <div class="cloud-banner-logos">
                    <span class="banner-intel">intel.</span>
                    <span class="banner-amd"><small>AMD</small>RYZEN</span>
                  </div>
                </a>
              </div>
            } @else if (category.id === 'network') {
              <div class="cloud-layout">
                <!-- Left: Intro -->
                <div class="cloud-intro">
                  <span class="cloud-brand"
                    >{{ 'header.network.universeLabel' | transloco }}<br /><strong>{{
                      'header.network.universeBrand' | transloco
                    }}</strong></span
                  >
                  <p class="cloud-tagline">{{ 'header.network.tagline' | transloco }}</p>
                  <p class="cloud-desc">{{ 'header.network.description' | transloco }}</p>
                </div>

                <!-- Center: Products -->
                <div class="cloud-products">
                  <a routerLink="/datacenter" (click)="closeAll()" class="cloud-product">
                    <img
                      src="logos/dc.png"
                      alt="Datacenter"
                      width="1254"
                      height="1254"
                      loading="lazy"
                      decoding="async"
                      class="cloud-logo-img"
                    />
                    <div class="cloud-product-info">
                      <span class="cloud-product-name">{{ 'header.network.datacenter' | transloco }}</span>
                      <span class="cloud-product-desc">{{ 'header.network.datacenterDesc' | transloco }}</span>
                    </div>
                  </a>
                  <a routerLink="/ip-tunnels" (click)="closeAll()" class="cloud-product">
                    <img
                      src="logos/tunnel.png"
                      alt="Tunnels IP"
                      width="1254"
                      height="1254"
                      loading="lazy"
                      decoding="async"
                      class="cloud-logo-img"
                    />
                    <div class="cloud-product-info">
                      <span class="cloud-product-name">{{ 'header.network.tunnelsIp' | transloco }}</span>
                      <span class="cloud-product-desc">{{ 'header.network.tunnelsIpDesc' | transloco }}</span>
                    </div>
                  </a>
                  <a routerLink="/antiddos" (click)="closeAll()" class="cloud-product">
                    <img
                      src="logos/ddos.png"
                      alt="Anti-DDoS"
                      width="1254"
                      height="1254"
                      loading="lazy"
                      decoding="async"
                      class="cloud-logo-img"
                    />
                    <div class="cloud-product-info">
                      <span class="cloud-product-name">{{ 'header.network.protectionDdos' | transloco }}</span>
                      <span class="cloud-product-desc">{{ 'header.network.protectionDdosDesc' | transloco }}</span>
                    </div>
                  </a>
                </div>

                <!-- Right: Promo cards -->
                <div class="cloud-promos">
                  <a routerLink="/datacenter" (click)="closeAll()" class="cloud-promo accent">
                    <div class="cloud-promo-top">
                      <div class="cloud-promo-text">
                        <span class="cloud-promo-label">{{ 'header.network.fullRack' | transloco }}</span>
                        <span class="cloud-promo-price">{{ 'header.network.fullRackPromo' | transloco }}</span>
                      </div>
                      <span class="brand-rack">42U</span>
                    </div>
                  </a>
                  <div class="cloud-promo subtle">
                    <span class="cloud-promo-sub">{{ 'header.network.fullRackPromoSub' | transloco }}</span>
                    <span class="cloud-promo-hint">{{ 'header.network.fullRackPromoHint' | transloco }}</span>
                  </div>
                </div>

                <!-- Bottom: Banner -->
                <a routerLink="/datacenter" (click)="closeAll()" class="cloud-banner net-banner">
                  <div class="cloud-banner-illus">
                    <svg viewBox="0 0 80 50" fill="none">
                      <circle
                        cx="40"
                        cy="25"
                        r="18"
                        stroke="rgba(168,85,247,0.4)"
                        stroke-width="1.2"
                        stroke-dasharray="4 3"
                      />
                      <circle cx="40" cy="25" r="8" stroke="rgba(168,85,247,0.6)" stroke-width="1.2" />
                      <circle cx="40" cy="25" r="2.5" fill="rgba(168,85,247,0.8)" />
                      <circle cx="20" cy="12" r="3" stroke="rgba(168,85,247,0.5)" stroke-width="1" />
                      <circle cx="60" cy="12" r="3" stroke="rgba(168,85,247,0.5)" stroke-width="1" />
                      <circle cx="20" cy="38" r="3" stroke="rgba(168,85,247,0.5)" stroke-width="1" />
                      <circle cx="60" cy="38" r="3" stroke="rgba(168,85,247,0.5)" stroke-width="1" />
                      <line x1="24" y1="14" x2="34" y2="21" stroke="rgba(168,85,247,0.3)" stroke-width="1" />
                      <line x1="56" y1="14" x2="46" y2="21" stroke="rgba(168,85,247,0.3)" stroke-width="1" />
                      <line x1="24" y1="36" x2="34" y2="29" stroke="rgba(168,85,247,0.3)" stroke-width="1" />
                      <line x1="56" y1="36" x2="46" y2="29" stroke="rgba(168,85,247,0.3)" stroke-width="1" />
                    </svg>
                  </div>
                  <div class="cloud-banner-center">
                    <span class="cloud-banner-title" [innerHTML]="'header.network.dcBanner' | transloco"></span>
                    <span class="cloud-banner-sub">{{ 'header.network.dcBannerSub' | transloco }}</span>
                  </div>
                  <div class="net-banner-certs">
                    <span class="net-cert">ISO 27001</span>
                    <span class="net-cert">SOC 2</span>
                  </div>
                </a>
              </div>
            } @else if (category.id === 'enterprise') {
              <div class="cloud-layout">
                <!-- Left: Intro -->
                <div class="cloud-intro">
                  <span class="cloud-brand"
                    >{{ 'header.enterprise.universeLabel' | transloco }}<br /><strong>{{
                      'header.enterprise.universeBrand' | transloco
                    }}</strong></span
                  >
                  <p class="cloud-tagline">{{ 'header.enterprise.tagline' | transloco }}</p>
                  <p class="cloud-desc">{{ 'header.enterprise.description' | transloco }}</p>
                </div>

                <!-- Center: Products -->
                <div class="cloud-products">
                  <a routerLink="/workspace" (click)="closeAll()" class="cloud-product">
                    <img
                      src="logos/o365.png"
                      alt="Microsoft 365"
                      width="1254"
                      height="1254"
                      loading="lazy"
                      decoding="async"
                      class="cloud-logo-img"
                    />
                    <div class="cloud-product-info">
                      <span class="cloud-product-name">{{ 'header.enterprise.microsoft365' | transloco }}</span>
                      <span class="cloud-product-desc">{{ 'header.enterprise.microsoft365Desc' | transloco }}</span>
                    </div>
                  </a>
                  <a routerLink="/workspace" (click)="closeAll()" class="cloud-product">
                    <img
                      src="logos/google.png"
                      alt="Google Workspace"
                      width="1254"
                      height="1254"
                      loading="lazy"
                      decoding="async"
                      class="cloud-logo-img"
                    />
                    <div class="cloud-product-info">
                      <span class="cloud-product-name">{{ 'header.enterprise.googleWorkspace' | transloco }}</span>
                      <span class="cloud-product-desc">{{ 'header.enterprise.googleWorkspaceDesc' | transloco }}</span>
                    </div>
                  </a>
                  <a routerLink="/fibre" (click)="closeAll()" class="cloud-product">
                    <img
                      src="logos/fibre.png"
                      alt="Fibre"
                      width="1254"
                      height="1254"
                      loading="lazy"
                      decoding="async"
                      class="cloud-logo-img"
                    />
                    <div class="cloud-product-info">
                      <span class="cloud-product-name">{{ 'header.enterprise.fibreOptique' | transloco }}</span>
                      <span class="cloud-product-desc">{{ 'header.enterprise.fibreOptiqueDesc' | transloco }}</span>
                    </div>
                  </a>
                  <a routerLink="/telephonie" (click)="closeAll()" class="cloud-product">
                    <img
                      src="logos/telephonie.png"
                      alt="VoIP"
                      width="1254"
                      height="1254"
                      loading="lazy"
                      decoding="async"
                      class="cloud-logo-img"
                    />
                    <div class="cloud-product-info">
                      <span class="cloud-product-name">{{ 'header.enterprise.telephonie' | transloco }}</span>
                      <span class="cloud-product-desc">{{ 'header.enterprise.telephonieDesc' | transloco }}</span>
                    </div>
                  </a>
                </div>

                <!-- Right: Promo cards -->
                <div class="cloud-promos">
                  <a routerLink="/contact" (click)="closeAll()" class="cloud-promo accent">
                    <div class="cloud-promo-top">
                      <div class="cloud-promo-text">
                        <span class="cloud-promo-label">{{ 'header.enterprise.promoBusiness' | transloco }}</span>
                        <span class="cloud-promo-price">{{ 'header.enterprise.promoBusinessPrice' | transloco }}</span>
                      </div>
                      <span class="brand-biz">PRO</span>
                    </div>
                  </a>
                  <div class="cloud-promo subtle">
                    <span class="cloud-promo-sub">{{ 'header.enterprise.promoBusinessSub' | transloco }}</span>
                    <span class="cloud-promo-hint">{{ 'header.enterprise.promoBusinessHint' | transloco }}</span>
                  </div>
                </div>
              </div>
            } @else if (category.id === 'web') {
              <div class="cloud-layout">
                <!-- Left: Intro -->
                <div class="cloud-intro">
                  <span class="cloud-brand"
                    >{{ 'header.web.universeLabel' | transloco }}<br /><strong>{{
                      'header.web.universeBrand' | transloco
                    }}</strong></span
                  >
                  <p class="cloud-tagline">{{ 'header.web.tagline' | transloco }}</p>
                  <p class="cloud-desc">{{ 'header.web.description' | transloco }}</p>
                </div>

                <!-- Center: Products -->
                <div class="cloud-products">
                  <a routerLink="/domains" (click)="closeAll()" class="cloud-product">
                    <img
                      src="logos/domain.png"
                      alt="Domaines"
                      width="1254"
                      height="1254"
                      loading="lazy"
                      decoding="async"
                      class="cloud-logo-img"
                    />
                    <div class="cloud-product-info">
                      <span class="cloud-product-name">{{ 'header.web.domains' | transloco }}</span>
                      <span class="cloud-product-desc">{{ 'header.web.domainsDesc' | transloco }}</span>
                    </div>
                  </a>
                  <a routerLink="/plesk" (click)="closeAll()" class="cloud-product">
                    <img
                      src="logos/plesk.png"
                      alt="Plesk"
                      width="1254"
                      height="1254"
                      loading="lazy"
                      decoding="async"
                      class="cloud-logo-img"
                    />
                    <div class="cloud-product-info">
                      <span class="cloud-product-name">{{ 'header.web.pleskHosting' | transloco }}</span>
                      <span class="cloud-product-desc">{{ 'header.web.pleskHostingDesc' | transloco }}</span>
                    </div>
                  </a>
                  <a routerLink="/ssl" (click)="closeAll()" class="cloud-product">
                    <img
                      src="logos/ssl.png"
                      alt="SSL"
                      width="1254"
                      height="1254"
                      loading="lazy"
                      decoding="async"
                      class="cloud-logo-img"
                    />
                    <div class="cloud-product-info">
                      <span class="cloud-product-name">{{ 'header.web.sslCertificates' | transloco }}</span>
                      <span class="cloud-product-desc">{{ 'header.web.sslCertificatesDesc' | transloco }}</span>
                    </div>
                  </a>
                </div>

                <!-- Right: Promo cards -->
                <div class="cloud-promos">
                  <a routerLink="/domains" (click)="closeAll()" class="cloud-promo accent">
                    <div class="cloud-promo-top">
                      <div class="cloud-promo-text">
                        <span class="cloud-promo-label">{{ 'header.web.promoFr' | transloco }}</span>
                        <span class="cloud-promo-price">{{ 'header.web.promoFrPrice' | transloco }}</span>
                      </div>
                      <span class="brand-tld-promo">.fr</span>
                    </div>
                  </a>
                  <div class="cloud-promo subtle">
                    <span class="cloud-promo-sub">{{ 'header.web.promoFrSub' | transloco }}</span>
                    <span class="cloud-promo-hint">{{ 'header.web.promoFrHint' | transloco }}</span>
                  </div>
                </div>

                <!-- Bottom: Banner -->
                <a routerLink="/domains" (click)="closeAll()" class="cloud-banner web-banner">
                  <div class="cloud-banner-illus">
                    <svg viewBox="0 0 80 50" fill="none">
                      <circle cx="40" cy="25" r="20" stroke="rgba(6,182,212,0.4)" stroke-width="1.2" />
                      <ellipse cx="40" cy="25" rx="10" ry="20" stroke="rgba(6,182,212,0.3)" stroke-width="1" />
                      <line x1="20" y1="18" x2="60" y2="18" stroke="rgba(6,182,212,0.25)" stroke-width="0.8" />
                      <line x1="20" y1="32" x2="60" y2="32" stroke="rgba(6,182,212,0.25)" stroke-width="0.8" />
                      <line x1="40" y1="5" x2="40" y2="45" stroke="rgba(6,182,212,0.2)" stroke-width="0.8" />
                      <circle cx="40" cy="25" r="3" fill="rgba(6,182,212,0.7)" />
                    </svg>
                  </div>
                  <div class="cloud-banner-center">
                    <span class="cloud-banner-title" [innerHTML]="'header.web.domainBanner' | transloco"></span>
                    <span class="cloud-banner-sub">{{ 'header.web.domainBannerSub' | transloco }}</span>
                  </div>
                  <div class="net-banner-certs">
                    <span class="net-cert">ICANN</span>
                    <span class="net-cert">AFNIC</span>
                  </div>
                </a>
              </div>
            }
          }
        }
      </div>
    }
  </div>
</div>

<!-- Spacer for fixed header -->
<div class="head-spacer" aria-hidden="true"></div>
